import React from "react";

export default function ProfileOverview({ profile, snapshot }) {
  const details = snapshot?.profile || {};
  const initials = (profile?.displayName || "Cryptember User").split(/\s+/).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
  return <section className="profile-card" aria-labelledby="profile-overview-title">
    <h2 id="profile-overview-title">Overview</h2>
    <div className="profile-identity">
      {profile?.avatarDataUrl ? <img className="profile-avatar" src={profile.avatarDataUrl} alt="Telegram profile" />
        : <div className="profile-avatar profile-initials" aria-label="Profile initials">{initials}</div>}
      <div><strong>{profile?.displayName || "Cryptember user"}</strong>{profile?.username && <div>@{profile.username}</div>}<small>Telegram profile fields are read-only and shown only for this session.</small></div>
    </div>
    <dl className="profile-facts"><div><dt>Plan</dt><dd>{details.plan || "Free"}</dd></div><div><dt>Status</dt><dd>{details.accountStatus || "Active"}</dd></div><div><dt>Subscription expiry</dt><dd>{details.subscriptionUntil ? new Date(details.subscriptionUntil).toLocaleDateString() : "No active paid subscription"}</dd></div></dl>
  </section>;
}
